@if (ultimasPrevisiones.length === 0) {
    <p>No hay datos disponibles</p>
} @else {
    <div class="container">
        <app-prevision-interna-table
            [lugar]="'home'"
            [pedidos]="ultimasPrevisiones"
        ></app-prevision-interna-table>
    </div>
}
